module.exports = __webpack_public_path__ + "img/other_kid_at_piano.c8c6fb55.jpg";